import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "columns is-gapless" }
const _hoisted_3 = { class: "column" }
const _hoisted_4 = { class: "card" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("header", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "card-header-title" }, "Wrwlf!")
], -1)
const _hoisted_6 = { class: "card-content" }
const _hoisted_7 = { class: "content" }
const _hoisted_8 = { class: "content" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "has-text-centered" }, "Join existing game", -1)
const _hoisted_10 = ["disabled"]
const _hoisted_11 = { class: "content" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", { class: "has-text-centered" }, "Create new game", -1)
const _hoisted_13 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _withDirectives(_createElementVNode("input", {
                class: "input",
                type: "text",
                placeholder: "Name",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.playerName) = $event))
              }, null, 512), [
                [_vModelText, _ctx.playerName]
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _withDirectives(_createElementVNode("input", {
                class: "input mb-3",
                type: "text",
                placeholder: "Game ID",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.joinGameId) = $event))
              }, null, 512), [
                [_vModelText, _ctx.joinGameId]
              ]),
              _createElementVNode("button", {
                class: _normalizeClass(
                  _ctx.loadingJoin
                    ? 'button is-dark is-fullwidth is-loading'
                    : 'button is-dark is-fullwidth'
                ),
                disabled: !_ctx.joinGameId || _ctx.loadingCreate,
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.joinExistingGame && _ctx.joinExistingGame(...args)))
              }, " Join ", 10, _hoisted_10)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("button", {
                class: _normalizeClass(
                  _ctx.loadingCreate
                    ? 'button is-black is-fullwidth is-loading'
                    : 'button is-black is-fullwidth'
                ),
                disabled: _ctx.loadingJoin,
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.createNewGame && _ctx.createNewGame(...args)))
              }, " Create ", 10, _hoisted_13)
            ])
          ])
        ])
      ])
    ])
  ]))
}